<template>
    <div class="mt-3 no-print">
        <div class="row">
            <div class="col">
                <h3>{{ name }}</h3>
            </div>
            <div class="col-2">
                <app-button v-if="addNew" native-type="button" type="success" class="float-right" @click="create">
                    {{ $t(title) }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdminHeader',
    props: {
        name: String,
        addNew: Boolean,
        title: {
            type: String,
            default: 'Create'
        }
    },
    methods: {
        create() {
            this.$emit('create');
        }
    }
};
</script>
